import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { FacilityInvitationMessagesApi } from '../../../apis/InvitationApi/FacilityInvitationMessagesApi.ts';
import { IFacilityInvitationMessages } from '../FacilityInvitationMessages.ts';

interface SaveInvitationMessagesVars {
    facilityId: number;
    messages: IFacilityInvitationMessages;
}

export function useSaveFacilityInvitationMessages() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    return useMutation<void, AppMedError, SaveInvitationMessagesVars>({
        mutationKey: [QueryKeys.facilityInvitationMessages, 'save'],
        mutationFn: ({ facilityId, messages }) =>
            FacilityInvitationMessagesApi.save(facilityId, messages),
        onSuccess: (_data, vars) => {
            queryClient.invalidateQueries({
                queryKey: [QueryKeys.facilityInvitationMessages, vars.facilityId],
            });
            notifications.show({
                color: 'green',
                message: t('invitationMessage.admin.saved'),
            });
        },
        onError: (err) => {
            notifications.show({ color: 'red', message: err.message });
        },
    });
}
